export function mergeImages(size, images) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = size.width;
  canvas.height = size.height;

  return Promise.all(
    images.map(
      ([src, rect]) =>
        new Promise(resolve => {
          const img = document.createElement('img');

          img.onload = () => {
            resolve([img, rect]);
          };
          img.crossOrigin = 'anonymous';
          img.src = src;
        })
    )
  ).then(imgs => {
    for (let [img, rect] of imgs) {
      ctx.drawImage(img, rect.x, rect.y, rect.width, rect.height);
    }

    return canvas.toDataURL('image/png');
  });
}
